import { render, staticRenderFns } from "./pageblock.vue?vue&type=template&id=4dfddc9c&"
import script from "./pageblock.vue?vue&type=script&lang=js&"
export * from "./pageblock.vue?vue&type=script&lang=js&"
import style0 from "./pageblock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports